// src/api/apiConfig.js

// const BASE_URL = 'http://localhost:1947/api';
// const BASE_IMG_URL = 'http://localhost:1950/img/';
// const BASE_PIMG_URL = 'http://localhost:2577/profile/';

const BASE_URL = 'https://api.luvmarry.com/api';
const BASE_IMG_URL = 'https://img.luvmarry.com/img/';
const BASE_PIMG_URL = 'https://img.luvmarry.com/profile/';


export const API_ENDPOINTS = {
  SIGNUP: `${BASE_URL}/signup/`,
  VERIFY_OTP: `${BASE_URL}/verifySOTP`,
  DETAILS: `${BASE_URL}/details`,
  PHOTOS: `${BASE_URL}/profileImg`,
  LOGIN:`${BASE_URL}/login`,
  FORGOTPSWD:`${BASE_URL}/forgotPassword`,
  CHANGEPSWD:`${BASE_URL}/changePassword`,
  SEARCH:`${BASE_URL}/Search`,
  GETPPHOTO:`${BASE_URL}/getProfilePhoto`,
  SENTMSG:`${BASE_URL}/message`,
  MSGGET:`${BASE_URL}/msgGet`,
  ACCEPT:`${BASE_URL}/accept`,
  GETDETAILS:`${BASE_URL}/getDetails`,
  GETDETAILSBYID:`${BASE_URL}/getDetailsbyID`,
  DELETEPHOTO:`${BASE_URL}/deletePhoto`,
  DAYMSGCOUNT:`${BASE_URL}/dayMsgCount`,
  DELETEACOUNT:`${BASE_URL}/deleteAccount`,
  LOGOUT:`${BASE_URL}/logout`,
  BASEIMGURL:BASE_IMG_URL,
  BASE_PIMG_URL:BASE_PIMG_URL
};
